<template>
  <div class="checkbox-box">
    <div
      :aria-checked="selectAll"
      class="checkbox"
      role="checkbox"
      tabindex="0"
      @click="allSelect(selectAll)"
      @keydown.space="(event) => handleSpaceKey(event, selectAll)"
    >
      <label class="checkbox__label" />
      <input :checked="selectAll" tabindex="-1" type="checkbox" />
      <span class="checkmark" />
    </div>
    <span class="label-select"> {{ $t('general__data__select-all') }}</span>
  </div>
</template>

<script lang="ts" setup>
interface EMITS {
  (e: 'selectAll', selectAll)
}
const emits = defineEmits<EMITS>()
interface PROPS {
  selectAll: boolean
}
defineProps<PROPS>()

function allSelect(selectAll: boolean) {
  emits('selectAll', !selectAll)
}
function handleSpaceKey(event: KeyboardEvent, selectAll: boolean) {
  event.preventDefault()
  allSelect(selectAll)
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.label-select {
  padding-left: 10px;
  font-size: 12px;
  font-weight: 400;
}
.checkbox-box {
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
}
.checkbox-box input {
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox {
  display: block;
  width: 16px;
  height: 16px;
  background: #f8f8f8;
  box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  position: relative;
  transition: background-color 0.4s;
  cursor: pointer;
}

.checkmark {
  cursor: pointer;
  width: 100%;
}

.checkbox .checkmark:after {
  content: '';
  position: absolute;
  width: 4px;
  height: 9px;
  border-right: 2px solid #353b40;
  border-bottom: 2px solid #353b40;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(4);
  transition: all 0.4s;
  opacity: 0;
  pointer-events: none;
}

.checkbox input:checked ~ .checkmark:after {
  opacity: 1;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
}

.checkbox input:checked ~ .checkmark {
  background-color: variables.$color-grey-lighter;
}

@media screen and (max-width: 1024px) {
  .label-select {
    font-size: 14px;
    font-family: Inter, sans-serif;
  }
  .checkbox {
    width: 24px;
    height: 24px;
  }

  .checkbox-box {
    padding: 0 0 24px;
  }

  .checkbox .checkmark:after {
    width: 8px;
    height: 20px;
  }
}
</style>
